import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import Pusher from 'pusher-js';
import {useEffect} from 'react';
import Cookies from "js-cookie";

import {productUpdated, couponUpdated, storeCloseEvent} from '../../store/actions/liveEvents';
import { syncCookiesToStore } from "../../store/actions/auth";
import Notifier from "react-desktop-notification";

const ComponentWrapper = ({Component, pageProps}) => {
    // if (process.env.environment !== 'dev') {
    //     let user = useSelector(state => state.auth.user) || null;
    //     if (user) {
    //         user = JSON.parse(user);
    //         LogRocket.identify(user.id, {
    //             name: user.first_name + ' ' + user.last_name,
    //             email: user.email
    //         })
    //     }
    // }
    const dispatch = useDispatch();

    const gotNewNotification = () => {
        console.log('got here');
        Notifier.focus('Title', "Here is context", "www.google.com", 'validated image url');
    }

    React.useEffect(() => {
        const data = [];
         //data['user'] = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null;
         data['user'] = Cookies.get('user') ? JSON.parse(Cookies.get('user')) :  localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
        data['token'] = Cookies.get('token');
        data['loggedIn'] = !!(data['user'] && data['token']);

        dispatch(syncCookiesToStore(data))
    }, []);

    useEffect(() => {
  const initPusher = () => {
    const pusher = new Pusher('df79bf68c713f8de0544', {
      cluster: 'eu',
      forceTLS: true
    });
    
    // your channel subscriptions here
     const pushNotificationChannel = pusher.subscribe('new-push-notification');
        pushNotificationChannel.bind('App\\Events\\NewPushNotification', ({title, body}) => {
            Notifier.focus(title, body, "https://kilimanjaro-restaurants.com/notifications", 'https://admin.kilimanjaro-restaurants.com/images/favicon.png');
        });

        // Live Product Update
        const productChannel = pusher.subscribe('product-updated');
        productChannel.bind('App\\Events\\ProductUpdated', eventData => {
            // dispatch(productUpdated(true));
            
        });

        //Coupon Product Update
        const couponChannel = pusher.subscribe('coupon-updated');
        couponChannel.bind('App\\Events\\CouponUpdated', eventData => {
            //  console.log(eventData, 'couponUpdated.........');
            dispatch(couponUpdated(true));
        });

        //Store Closes Event
        const storeCloseChannel = pusher.subscribe('close-restaurants');
        storeCloseChannel.bind('App\\Events\\CloseRestaurantsEvent', eventData => {
            dispatch(storeCloseEvent(true));
        });

        //Store Opens Event
        const storeOpenChannel = pusher.subscribe('open-restaurants');
        storeOpenChannel.bind('App\\Events\\OpenRestaurantsEvent', eventData => {
            dispatch(storeCloseEvent(false));
        });
  };

  // delay Pusher until page is fully loaded
  if (document.readyState === "complete") {
    setTimeout(initPusher, 3000); // 3 second delay after load
  } else {
    window.addEventListener("load", () => setTimeout(initPusher, 3000));
  }
}, []);

    // useEffect(() => {
    //     Pusher.logToConsole = false;
    //     // const pusher = new Pusher('8d0fc5535e8e8d125d2c', {
    //     const pusher = new Pusher('df79bf68c713f8de0544', {
    //         cluster: 'eu',
    //         forceTLS: true
    //     });

    //     // Push Notification
    //     const pushNotificationChannel = pusher.subscribe('new-push-notification');
    //     pushNotificationChannel.bind('App\\Events\\NewPushNotification', ({title, body}) => {
    //         Notifier.focus(title, body, "https://kilimanjaro-restaurants.com/notifications", 'https://admin.kilimanjaro-restaurants.com/images/favicon.png');
    //     });

    //     // Live Product Update
    //     const productChannel = pusher.subscribe('product-updated');
    //     productChannel.bind('App\\Events\\ProductUpdated', eventData => {
    //         // dispatch(productUpdated(true));
    //         console.log(eventData, 'productUpdated.........');
    //     });

    //     //Coupon Product Update
    //     const couponChannel = pusher.subscribe('coupon-updated');
    //     couponChannel.bind('App\\Events\\CouponUpdated', eventData => {
    //         //  console.log(eventData, 'couponUpdated.........');
    //         dispatch(couponUpdated(true));
    //     });

    //     //Store Closes Event
    //     const storeCloseChannel = pusher.subscribe('close-restaurants');
    //     storeCloseChannel.bind('App\\Events\\CloseRestaurantsEvent', eventData => {
    //         dispatch(storeCloseEvent(true));
    //     });

    //     //Store Opens Event
    //     const storeOpenChannel = pusher.subscribe('open-restaurants');
    //     storeOpenChannel.bind('App\\Events\\OpenRestaurantsEvent', eventData => {
    //         dispatch(storeCloseEvent(false));
    //     });

    // }, []);

    // useEffect(() => {
    //     if (location.href === '/checkout') {
    //         jQuery.noConflict();
    //         $('#disclaimer').modal('show');
    //         return;
    //     }
    //     // $('#disclaimer').modal('show');
    // }, []);

    return <Component {...pageProps} />
}

export default ComponentWrapper;
